export function isString(value: any): value is string {
	return typeof value === 'string' || Object.prototype.toString.call(value) === "[object String]";
}

export function isFunction(value: any): value is Function {
	return typeof value === 'function' || Object.prototype.toString.call(value) === "[object Function]";
}

export function isNumber(value: any): value is number {
	return typeof value === 'number' || Object.prototype.toString.call(value) === "[object Number]";
}

export function isBoolean(value: any): value is boolean {
	return typeof value === 'boolean' || Object.prototype.toString.call(value) === "[object Boolean]";
}

export function isObject(value: any): value is Object {
	return value !== null && typeof value === 'object' || Object.prototype.toString.call(value) === "[object Object]";
}

export function isArray(value: any): value is Array<any> {
	return Array.isArray(value);
}

export function isUndefined(value: any): value is undefined {
	return typeof value === 'undefined';
}

export function isSymbol(value: any): value is symbol {
	return typeof value === 'symbol' || Object.prototype.toString.call(value) === "[object Symbol]";
}

export function isBigInt(value: any): value is bigint {
	return typeof value === 'bigint' || Object.prototype.toString.call(value) === "[object BigInt]";
}

export function isDate(value: any): value is Date {
	return value instanceof Date || Object.prototype.toString.call(value) === "[object Date]";
}